import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchKnmRejectReasonTypes } from 'APIPackage/CatalogsModule/services/knmRejectReasonTypesApi';
import { IKnmRejectReasonType } from 'APIPackage/CatalogsModule/interfaces/IKnmRejectReasonType';
import { createKnmRejectReasonTypeSelectOption } from 'CorePackage/CatalogsModule/common/createKnmRejectReasonTypeSelectOption';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';

import { IKnmRejectReasonTypeSelectOption } from '../interfaces/IKnmRejectReasonTypeSelectOption';

const emptyKnmRejectReasonTypes: IKnmRejectReasonType[] = [];

export function useKnmRejectReasonTypes(knmTypeId?: number) {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [knmRejectReasonTypes, setKnmRejectReasonTypes] = useState<Array<IKnmRejectReasonType>>(
    emptyKnmRejectReasonTypes,
  );
  const [knmRejectReasonTypesOptions, setKnmRejectReasonTypesOptions] = useState<IKnmRejectReasonTypeSelectOption[]>(
    [],
  );
  const isMounted = useMountedState();

  const refresh = useCallback(
    async id => {
      try {
        dispatch(coreSetLoading(true));
        const types = await fetchKnmRejectReasonTypes(id);

        isMounted() && setKnmRejectReasonTypes(types);
      } finally {
        dispatch(coreSetLoading(false));
      }
    },
    [dispatch, isMounted],
  );

  useEffect(() => {
    if (typeof knmTypeId === 'number') {
      refresh(knmTypeId);
    } else {
      setKnmRejectReasonTypes(emptyKnmRejectReasonTypes);
    }
  }, [refresh, knmTypeId]);

  useEffect(() => {
    setKnmRejectReasonTypesOptions(
      knmRejectReasonTypes.map(knmRejectReasonType => createKnmRejectReasonTypeSelectOption(knmRejectReasonType)),
    );
  }, [knmRejectReasonTypes]);

  return {
    refresh,
    knmRejectReasonTypes,
    knmRejectReasonTypesOptions,
  };
}
